export default [
    {
        path: '/bills/:id',
        name: 'bill',
        component: () => import( /* webpackChunkName: "bill" */ '@/views/bill/Bill.vue')
    },
    {
        path: '/bills/:id/email',
        name: 'billEmail',
        component: () => import( /* webpackChunkName: "billEmail" */ '@/views/bill/BillEmail.vue')
    },
    {
        path: '/billTemplates',
        name: 'billTemplates',
        component: () => import( /* webpackChunkName: "billTemplates" */ '@/views/bill/BillTemplates.vue')
    },
    {
        path: '/billTemplates/:id',
        name: 'billTemplate',
        component: () => import( /* webpackChunkName: "billTemplate" */ '@/views/bill/BillTemplate.vue')
    },
    {
        path: '/bills',
        name: 'billDiary',
        component: () => import( /* webpackChunkName: "billDiary" */ '@/views/bill/BillDiary.vue')
    },
    {
        path: '/ledger/:office/:id',
        name: 'ledger',
        component: () => import( /* webpackChunkName: "ledger" */ '@/views/bill/Ledger.vue')
    },
    {
        path: '/ledgers',
        name: 'ledgers',
        component: () => import( /* webpackChunkName: "ledgers" */ '@/views/bill/Ledgers.vue')
    },
    {
        path: '/vatAction/:id',
        name: 'vatAction',
        component: () => import( /* webpackChunkName: "vat" */ '@/views/bill/VatAction.vue')
    },
    {
        path: '/vatActions',
        name: 'vatActions',
        component: () => import( /* webpackChunkName: "vat" */ '@/views/bill/VatActions.vue')
    },
    {
        path: '/vatCreate',
        name: 'vatCreate',
        component: () => import( /* webpackChunkName: "vat" */ '@/views/bill/VatCreate.vue')
    },
    {
        path: '/vatTest',
        name: 'vatTest',
        component: () => import( /* webpackChunkName: "vat" */ '@/views/bill/VatTest.vue')
    }
]